module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2 class="coach-title">Transaction History</h2>\n\n<div class="coach-table">\n  <header class="coach-table-header">\n    <div class="column column-1 subscription">Subscription</div>\n    <div class="column column-2 status">Status</div>\n    <div class="column column-3 start-date">Start Date</div>\n    <div class="column column-4 end-date">End Date</div>\n  </header>\n  <div class="coach-table-body">\n    ';
 _.each(transactions, function(transaction){ 
__p+='\n      <div class="coach-table-row">\n        <div class="column column-1 subscription">\n          '+
((__t=( transaction.plan ))==null?'':_.escape(__t))+
'\n        </div>\n        <div class="column column-2 status">\n          '+
((__t=( transaction.status ))==null?'':_.escape(__t))+
'\n        </div>\n        <div class="column column-3 start-date">\n          '+
((__t=( transaction.start ))==null?'':_.escape(__t))+
'\n        </div>\n        <div class="column column-4 end-date">\n          '+
((__t=( transaction.end ))==null?'':_.escape(__t))+
'\n        </div>\n      </div>\n      ';
 }) 
__p+='\n  </div>\n</div>\n\n';
 if(has_active_month_subscription || assistant_coach_plan==='trial' ){ 
__p+='\n  <button type="submit" class="primary-btn cancel-subscription js-cancel-subscription">cancel subscription</button>\n  ';
 } 
__p+='';
}
return __p;
};
